import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from 'src/app/shared/material/material.module';

import { SharedModule } from 'src/app/shared/shared.module';
import { RemoveProfileRoutingModule } from './remove-profile-routing.module';
import { RemoveProfileComponent } from './remove-profile.component';

@NgModule({
  declarations: [RemoveProfileComponent],
  imports: [
    CommonModule,
    RemoveProfileRoutingModule,
    SharedModule,
  ],
})
export class RemoveProfileModule { }
